import styled, { css, RuleSet } from 'styled-components';
import { Breakpoints } from '../../../styled/constants';
import { FlexCenterAligned, imagePreviewStyles } from '../../../styled/common';
import { Typography } from '../Typography';

export const SliderWrapper = styled.div`
  position: relative;
`;

export const Slider = styled.div<{
  $photosCount?: number;
  $styles?: RuleSet<object>;
}>`
  display: grid;
  height: 330px;
  overflow-x: scroll;
  scroll-snap-type: x mandatory;
  scrollbar-width: none;
  cursor: pointer;
  -webkit-tap-highlight-color: transparent;
  overflow-y: hidden;

  grid-template-columns: ${({ $photosCount }) =>
    `repeat(${$photosCount}, 100%)`};

  @media (min-width: ${Breakpoints.tablet}px) {
    border-radius: 14px;
    height: 506px;
  }

  @media (min-width: ${Breakpoints.smallDesktop}px) {
    height: 480px;
  }

  ${({ $styles }) => $styles};
`;

export const Slide = styled.div<{
  $withBlur?: boolean;
  $isFullScreen?: boolean;
}>`
  ${imagePreviewStyles};
  scroll-snap-align: start;
  scroll-snap-stop: always;
  width: 100%;
  height: 330px;
  display: flex;
  position: relative;
  overflow: hidden;

  ${({ $withBlur }) =>
    !$withBlur &&
    css`
      background-color: transparent;
    `};

  @media (min-width: ${Breakpoints.tablet}px) {
    height: 506px;
  }

  @media (min-width: ${Breakpoints.smallDesktop}px) {
    height: 480px;
  }

  ${({ $isFullScreen }) =>
    !$isFullScreen &&
    css`
      justify-content: center;
      align-items: center;

      iframe {
        width: 800px;
        height: 600px;
      }
    `};
`;

export const GalleryActionButton = styled(FlexCenterAligned)`
  width: 40px;
  height: 40px;
  border-radius: 50%;
  position: absolute;
  opacity: 0;
  transition: opacity 0.4s ease-in-out;
  background-color: #000;
  cursor: pointer;
  z-index: 3;

  @media (hover: hover) and (pointer: fine) {
    ${Slider}:hover & {
      opacity: 0.6;
    }
  }

  &:focus-visible {
    opacity: 0.6;
  }
`;

export const FullScreenButton = styled(GalleryActionButton)`
  top: 10px;
  right: 25px;
  background-image: url('/static/images/item/scale.svg');
  background-size: 14px 14px;
  background-repeat: no-repeat;
  background-position: center;
`;

const ArrowButton = styled(GalleryActionButton)`
  top: 50%;
  transform: translate(0, -50%);
  background-image: url('/static/images/item/arrow-left.svg');
  background-size: 8px 16px;
  background-repeat: no-repeat;
  background-position: center;
`;

export const LeftArrow = styled(ArrowButton)`
  left: 25px;
`;

export const RightArrow = styled(ArrowButton)`
  right: 25px;
  transform: translate(0, -50%) rotate(180deg);
`;

export const SlideWrapper = styled.div<{
  $photo: string;
}>`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  background-image: url(${({ $photo }) => $photo});
  background-size: cover;
  background-position: center;
  filter: blur(20px);
  transform: scale(1.1);
  z-index: 0;
  pointer-events: none;
  contain: paint;
`;

export const SlideImage = styled.img`
  width: 100%;
  height: 100%;
  object-fit: contain;
  margin: auto;
  position: relative;
  z-index: 2;
`;

export const SlidePicture = styled.picture`
  display: block;
  width: 100%;
  height: 100%;
`;

export const Overlay = styled(FlexCenterAligned)`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 9;
  background: rgba(0, 0, 0, 0.6);
  pointer-events: none;

  @media (min-width: ${Breakpoints.tablet}px) {
    border-radius: 14px;
  }
`;

export const OverlayText = styled(Typography)`
  color: ${({ theme }) => theme.colors.text.white};
`;
